import axios from 'axios'
import { Environment } from 'src/lib'
import { CloseAvailyContextProps } from '@context/CloseAvailyContext'
import config, { ENV_VARIABLES } from '../config'

type InitConfig = {
  iframeId?: string
  wrapperId: string
  transform: {
    /*
     * A function with access to the iframe that will be executed before the iframe is appended to the document
     */
    beforeAppend: (iframe: HTMLIFrameElement) => void
  }
  closeAvaily: CloseAvailyContextProps
  params?: string
}

const getHTMLUrl = (environment: Environment) =>
  `https://dental21-ana${environment === 'production' ? '' : '-staging'}.s3.eu-central-1.amazonaws.com/index.html`

const getUrl = (environment: Environment) => {
  if (environment === 'production') return 'https://ana.dental21.de'

  return 'https://staging-ana.dental21.de'
}

const getHTML = async (): Promise<string> => {
  const environment = (config(ENV_VARIABLES.ENV) || 'development') as Environment
  const url = getHTMLUrl(environment)

  return axios.get(url).then(({ data }) => {
    return data.replace(/\.\/static\//g, `${getUrl(environment)}/static/`)
  })
}

const createIFrame = (htmlContent: string, config: InitConfig): HTMLIFrameElement => {
  const iframe = document.createElement('iframe')
  const anaWrapper = document.getElementById(config.wrapperId)

  iframe.id = config.iframeId || 'ana-iframe'
  iframe.style.width = '100%'
  iframe.style.border = 'none'
  iframe.dataset.testid = 'ana-iframe'

  config.transform.beforeAppend(iframe)

  if (!anaWrapper) throw new Error('Could not find an element with id `ana-wrapper`')

  anaWrapper.append(iframe)

  if (iframe.contentDocument && iframe.contentWindow) {
    iframe.contentDocument.open()
    iframe.contentWindow?.history.pushState(
      '',
      iframe.contentDocument.title,
      `${iframe.contentDocument.location.origin}${config.params}`
    )

    iframe.contentDocument.write(htmlContent)

    iframe.contentDocument.close()

    iframe.contentWindow.onbeforeunload = function () {
      config.closeAvaily?.()
    }
  }

  return iframe
}

const init = async (config: InitConfig): Promise<HTMLIFrameElement> => {
  const htmlContent = await getHTML()

  return createIFrame(htmlContent, config)
}

const anaModule = { init }

export default anaModule
